import { useState } from "react";
import { useNavigate } from "react-router-dom";

export function useDistributorSignin() {
  const navigate = useNavigate();
  const [form, setForm] = useState({ email: "", password: "" });
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState("");

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    setError("");
    try {
      const response = await fetch(
        `${process.env.REACT_APP_SERVER_PATH}/vendor/signin`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ email: form.email, password: form.password }),
        }
      );

      if (!response.ok) {
        let message = `Signin failed (${response.status})`;
        try {
          const err = await response.json();
          if (err && (err.message || err.error)) {
            message = err.message || err.error;
          }
        } catch {}
        throw new Error(message);
      }

      let token;
      let user = null;
      const contentType = response.headers.get("content-type") || "";
      if (contentType.includes("application/json")) {
        const data = await response.json();
        if (typeof data === "string") {
          token = data;
        } else {
          token = data.token;
          user = data.user || data.vendor || null;
        }
      } else {
        token = await response.text();
      }

      if (!token) {
        throw new Error("No token received from server");
      }

      localStorage.setItem("token", token);
      if (user) {
        try {
          localStorage.setItem("user", JSON.stringify(user));
        } catch {}
      }
      navigate("/products");
    } catch (err) {
      setError(err.message || "Signin failed");
    } finally {
      setSubmitting(false);
    }
  };

  return {
    form,
    submitting,
    error,
    handleChange,
    handleSubmit,
  };
}
